import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { cities } from '../data/cityData';
import { cityPath } from '../utils/seo';

/**
 * Every service area links to its own city landing page. Order follows
 * cityData (Camarillo first).
 */
export function ServiceAreas() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" id="service-areas" data-id="element-406" data-mp="2pq27ok8zwlio">
      <div className="max-w-5xl mx-auto" data-id="element-407" data-mp="2bugq2y53d40a">
        <div className="text-center mb-12" data-id="element-408" data-mp="2gs04pz5pbisr">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-black uppercase mb-4" data-id="element-409" data-mp="2gsrzx8vdzeii">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-410" data-mp="22ta3q8frgyz4">
              Mobile Car Detailing Service Areas
            </span>
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-411" data-mp="10uejuaz7mw4" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mt-4" data-id="element-412" data-mp="514qropd39jf">
            Mike's Pro Detail is a mobile business — we bring the detail shop to
            your driveway anywhere in Ventura County and select surrounding
            areas. Choose your city for local details.
          </p>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-413" data-mp="g1x4rk5zmaoa">
          {cities.map((city, index) => <motion.li key={city.slug} initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: Math.min(index * 0.04, 0.3),
          duration: 0.2
        }} data-id="element-414" data-mp="b33q3oeysdmj" data-mpi={index}>
              <Link to={cityPath(city.slug)} className="h-full bg-zinc-900/40 border border-zinc-800 rounded-lg px-4 py-3 flex items-center gap-3 hover:border-red-900/50 hover:bg-zinc-900/70 transition-colors duration-150" data-id="element-415" data-mp="3ofxb49qhyjsl">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0" aria-hidden="true" data-id="element-416" data-mp="13q7zs6p05g4n" />
                <span className="flex flex-col min-w-0 text-left" data-id="element-417" data-mp="1atef2mkv7g8s">
                  <span className="text-white font-bold text-base leading-tight" data-id="element-418" data-mp="1frppayf2nsrj">
                    {city.name}
                  </span>
                  <span className="text-gray-400 text-sm leading-tight" data-id="element-419" data-mp="1kru7qtzjixke">
                    Mobile Car Detailing {city.name}
                  </span>
                </span>
              </Link>
            </motion.li>)}
        </ul>

        <p className="text-sm text-center mt-8 text-[#FFFFFF]" data-id="element-420" data-mp="s3ydrx1cvjrb">
          Don't see your area? Call{' '}
          <a href="tel:8183819905" className="text-red-500 font-bold hover:underline" style={{
          fontSize: "24px"
        }} data-id="element-421" data-mp="x1hqgsienoh5">
            (818) 381-9905
          </a>{' '}
          — we may still be able to come to you!
        </p>
      </div>
    </section>;
}